<template>
  <a-layout class="layout__page-container">
    <a-layout-sider class="layout__side-nav" v-if="_user.can.viewAdminNav" width="200">
      <a-menu class="menu-list" mode="inline">
        <a-menu-item :class="{'ant-menu-item-selected': $route.path == '/'}">
          <router-link to="/">
            <a-icon type="home"/>
            <span>Home</span>
          </router-link>
        </a-menu-item>
        <a-menu-item :class="{'ant-menu-item-selected': $route.path == '/admin/projects'}">
          <router-link to="/admin/projects">
            <a-icon type="folder-open"/>
            <span>Models</span>
          </router-link>
        </a-menu-item>
        <a-menu-item :class="{'ant-menu-item-selected': $route.path == '/admin/events'}">
          <router-link to="/admin/events">
            <a-icon type="environment"/>
            <span>Events</span>
          </router-link>
        </a-menu-item>
        <a-menu-item :class="{'ant-menu-item-selected': $route.path == '/admin/users'}">
          <router-link to="/admin/users">
            <a-icon type="team"/>
            <span>Users</span>
          </router-link>
        </a-menu-item>
        <a-menu-item :class="{'ant-menu-item-selected': $route.path == '/admin/datasources'}">
          <router-link to="/admin/datasources">
            <a-icon type="database"/>
            <span>Datasources</span>
          </router-link>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>

    <a-layout style="overflow-y: scroll;">
      <a-layout-content style="padding: 50px;">
        <router-view/>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import store from "@/store/index";

export default {
  name: "home",
  data() {
    return {
      viewModes: {
        admin: {
          label: "Admin",
          value: "admin"
        },
        consultant: {
          label: "Consultant",
          value: "consultant"
        }
      },
      viewMode: this.$store.state.viewMode
    };
  },
  watch: {
    viewMode: {
      handler(val) {
        if (val) {
          this.$store.commit("SET_VIEW_MODE", val);
          this.$router.push("/");
        }
      }
    }
  },
  methods: {},
  components: {},
  created() {
    this.$store.commit("SET_IS_FETCHING", true);
    this.$store
      .dispatch("user/fetchAll")
      .then(() => {
        this.$store.commit("SET_IS_FETCHING", false);
      })
      .catch(e => {
        this.$store.commit("SET_IS_FETCHING", false);
      });
  },
  async beforeRouteEnter(ro, from, next) {
    await store.dispatch("event/fetchAll");
    await store.dispatch("project/fetchAll");
    next();
  }
};
</script>

<style lang="scss" scoped>
.layout {
  &__side-nav {
    width: 350px;
  }
  &__page-container {
    // height: 100%;
  }
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.menu-list {
  height: 100%;
  background: $--color-app-bg;
}
</style>

